var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "hero is-fullheight-with-navbar" }, [
    _c("div", { staticClass: "hero-head" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "columns is-vcentered",
            staticStyle: { "padding-top": "30px" },
          },
          [
            _vm._m(0),
            _vm.showButtonReturn
              ? _c(
                  "div",
                  {
                    staticClass: "column is-2",
                    on: { click: _vm.routerOrder },
                  },
                  [
                    _c("b-icon", {
                      staticClass: "cursorPoint",
                      attrs: {
                        type: "is-primary",
                        icon: "arrow-left",
                        size: "is-medium",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "column is-2" },
                  [
                    _vm.isAuthenticated
                      ? _c(
                          "b-button",
                          {
                            staticClass: "is-pulled-right is-info",
                            attrs: { rounded: "" },
                            on: { click: _vm.routerOrder },
                          },
                          [_vm._v("Histórico Pedidos")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
            _c("div", { staticClass: "column is-2" }, [
              _vm.isAuthenticated
                ? _c(
                    "a",
                    {
                      staticClass: "is-pulled-right",
                      on: { click: _vm.goOut },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "logout" } }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("app.logout")))]),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "hero-body" },
      [
        _c("offline", {
          on: { "detected-condition": _vm.handleConnectivityChange },
        }),
        _c("router-view"),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-8" }, [
      _c("img", {
        attrs: {
          src: require("./assets/logo.svg"),
          alt: "Sura",
          height: "200",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }